import { connect } from 'react-redux'
import { getUser, updateUser } from "../../graphqlDic";
import { compose, graphql } from "react-apollo";

import User from './../../components/Users/User'

const mapStateToProps = (state, props) => {
    if (props.getUser.getUser) {
        const { id, email, fullname } = props.getUser.getUser
        return {
            initialValues: { id, email, fullname }
        }
    }
    return {
        initialValues: null
    }
}

export default compose(
    graphql(getUser, {
        name: 'getUser',
        options: (props) => ({
            variables: {
                id: props.match.params.id
            }
        })
    }),
    graphql(updateUser)
)(connect(mapStateToProps, null)(User));



// WEBPACK FOOTER //
// ./src/containers/Users/User.js